import React, { useState, useEffect } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import "./Fatture.scss";
import { ReactComponent as Doc } from "../../assets/new-icons/doc.svg";
import { ReactComponent as Rai } from "../../assets/new-icons/rai.svg";
import { ReactComponent as Oneri } from "../../assets/new-icons/oneri.svg";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { setData } from "../../features/documentiSlice";
import Item from "./_Item";
import InvoiceDetail from "./_InvoiceDetail";
import { useNavigate } from "react-router-dom";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { DateTime } from "luxon";
import NewHeader from "../../components/New Header/NewHeader";
import Header from "../../components/Header in Page/_Header";

function Fatture() {
  const navigate = useNavigate()
  const dispatch = useDispatch();
  const customerCode = useSelector((user) => user.user.info.customer_code);
  const [tag, setTag] = useState("fattura");
  const [year, setYear] = useState(DateTime.now().toFormat('y'))
  const data = useSelector((user) => user.documenti.data);
  const [overlay, setOverlay] = useState(false);
  const [invoiceDetail, setInvoice] = useState(null);
  const [more, setMore] = useState(5);
  const [ascActive, setAsc] = useState(true)

  useEffect(() => {
    init();
  }, []);

useEffect(() => {
  document.body.style.overflow = "hidden";
  document.body.style.touchAction = "none";
}, [overlay])
  const init = async () => {
    const fattureApi = `https://my.revoluce.it/area_utente/gestione/api/deliveries/getDocumenti.php?codice_cliente=${customerCode}`;
    await axios.get(fattureApi).then(({ data }) => {
      const result = data.documenti.sort((a, b) =>
        a.data_emissione < b.data_emissione ? 1 : -1
      );
      dispatch(setData(result));
    });
  };
  function getOccurrence(array, value) {
    // return array.filter((v) => (v.tag === value)).length;
    return array.filter((v) => v.tag === value && v.data_emissione.includes(year)).length
  }
  const switchName = () => {
    switch (tag) {
      case "fattura":
        return "Consumi";
      case "rai":
        return "Canone RAI";

      default:
        return "Altri Oneri";
    }
  };
  const switchIcon = () => {
    switch (tag) {
      case "fattura":
        return <Doc className="doc" />;
      case "rai":
        return <Rai className="rai" />;
      case "fattura_oneri":
        return <Oneri className="doc" />;
      default:
        break;
    }
  };

  const handleTag = (e) => {
    setTag(e)
    setMore(5)
  }
  return (
    <>
      <div className="fatture">
        <div className="fatture-top">
          <NewHeader setOverlay={setOverlay} logo="white" padding="no" iconsColor="white" overlay={overlay} overlayTitle="Fatture"/>
        </div>

        {!overlay ? (
          <div className="fatture-bottom">
            <Header
              title="Fatture"
              description={`Qui riportati i documenti per la tua utenza. Controlla e scarica le tue fatture`}
            />
            <div className="tag-list">
              <p
                className="tag-item"
                style={tag === "fattura" ? { color: "#697386" } : null}
                onClick={() => handleTag('fattura')}
              >
                Consumi
              </p>
              <span className="line"></span>
              <p
                className="tag-item"
                style={tag === "rai" ? { color: "#697386" } : null}
                onClick={() => handleTag('rai')}
              >
                Canone
              </p>
              <span className="line"></span>
              <p
                className="tag-item"
                style={tag === "fattura_oneri" ? { color: "#697386" } : null}
                onClick={() => handleTag('fattura_oneri')}
              >
                Altri Oneri
              </p>
            </div>
            <div className="filter">
              <div className="dateFilter">
                <ArrowBackIosIcon onClick={() => getOccurrence(data,tag) === 0 ? null : setYear(DateTime.fromFormat(year, 'y').plus({ year: -1 }).toFormat('y'))} />
                <p className="main">{year}</p>
                <ArrowForwardIosIcon onClick={() => year === DateTime.now().toFormat('y') ? null : setYear(DateTime.fromFormat(year, 'y').plus({ year: +1 }).toFormat('y'))} />
              </div>
              <div className="ascFilter" onClick={() => setAsc(!ascActive)}>
                <p className="main">{ascActive ? 'Ascendente' : 'Discendente'}</p>
                {ascActive ? <ArrowDropDownIcon /> : <ArrowDropUpIcon />}
              </div>
            </div>
            {data !== null ? (
              <div className="item-list">
                {ascActive ? data
                  .filter((d) => tag === d.tag && d.data_emissione.includes(year))
                  .slice(0, more)
                  .map((r, i) => (
                    <Item
                      key={i}
                      data={r}
                      setOverlay={setOverlay}
                      setInvoice={setInvoice}
                    />
                  )) : data
                    .filter((d) => tag === d.tag && d.data_emissione.includes(year))
                    .slice(0, more)
                    .map((r, i) => (
                      <Item
                        key={i}
                        data={r}
                        setOverlay={setOverlay}
                        setInvoice={setInvoice}
                      />
                    )).reverse()}
              </div>
            ) : null}
             {data && more >= getOccurrence(data, tag) ? (
              <div className="more">
                <p>Niente da visualizzare</p>
              </div>
            ) : (
              <div className="more">
                <p onClick={() => setMore(more + 2)}>Mostra di più </p>
                <ArrowDropDownIcon />
              </div>
            )}
            <div className="empty" style={{height: '100px'}}></div>

          </div>
        ) : invoiceDetail !== null ? (
          <div className="fatture-bottom">
            <InvoiceDetail invoiceDetail={invoiceDetail} />
            <div className="empty" style={{height: '100px'}}></div>
          </div>
        ) : null}
      </div>
    </>
  );
}

export default Fatture;
